import { notification } from 'antd'
import { publicAPI } from '../../Config/Constant'
import store from '../store'



export const GetMyOrganizationUser = async(payload) => {
 
     try {
       const res = await publicAPI.post('/myorganization', payload)       
         if (res) {
          
            store.dispatch({
                type: 'SET_ALL_MY_ORGANIZATION_USERS',
                payload: res.data.data,
              })
    

          

            return res
           
         } 
         
     } catch (err) {
       console.error('Error during login:', err); 
       notification.error({
         message: err?.response?.data?.message || 'Server Error',
         duration: 3,
       })
     }
   
 }




 export const EditMemberOrganizationUser = async(payload) => {
 

   try {
     const res = await publicAPI.post('/myorganization/update', payload)
  



     
       if (res) {

        let myorganizationpayload={organization_ids:[payload.organization_id]}
        
        await GetMyOrganizationUser(myorganizationpayload)

        

          return res
         
       } 
       

     
   } catch (err) {
     console.error('Error during login:', err); 
     notification.error({
       message: err?.response?.data?.message || 'Server Error',
       duration: 3,
     })
   }
 
}

export const DeleteMemberOrganizationUser = async(payload) => {
 
   try {
     const res = await publicAPI.post('/myorganization/delete', payload)
  



     
       if (res) {

        let myorganizationpayload={organization_ids:[payload.organization_id]}
        
        await GetMyOrganizationUser(myorganizationpayload)

        

          return res
         
       } 
       

     
   } catch (err) {
     console.error('Error during login:', err); 
     notification.error({
       message: err?.response?.data?.message || 'Server Error',
       duration: 3,
     })
   }
 
}


export const getOrganizationBySlug = async (slug) => {
  try {

    const res = await publicAPI.get(`/myorganization/by-slug/${slug}`)
    
    console.log('API response:', res);
    
    if (res) {

        localStorage.setItem('organizationid', res.data.data.data.organizationid);
        console.log('Organization ID stored in localStorage:', res.data.data.data.organizationid);
        // Dispatch to Redux store
        store.dispatch({
          type: 'SET_ORGANIZATION_BY_SLUG',
          payload: res.data.data
        });
      
      
      return res.data.data;
    }
    
    return null;
  } catch (err) {
    console.error('Error getting organization by slug:', err);
    notification.error({
      message: err?.response?.data?.message || 'Server Error',
      duration: 3,
    })
    return null;
  }
}